// Talent Acquisition: the pipeline vocabulary shared by the API and the page.
//
// Lives on the frontend side, like rbac.js, so the Worker imports it from here
// and there is one list of stages rather than two that drift apart. The six
// stages were agreed with the Talent Acquisition Coordinator on 07 September
// 2026; references, right to work and DBS are not a stage here because they
// run in Onboarding once the offer is accepted.

export const STAGES = ['applied', 'screening', 'interview_1', 'interview_2', 'offer', 'accepted'];

export const STAGE_LABELS = {
  applied: 'Applied',
  screening: 'Screening',
  interview_1: 'Interview 1',
  interview_2: 'Interview 2',
  offer: 'Offer',
  accepted: 'Accepted',
};

export const SOURCES = ['linkedin', 'job_board', 'referral', 'other'];

export const SOURCE_LABELS = {
  linkedin: 'LinkedIn',
  job_board: 'Job board',
  referral: 'Referral',
  other: 'Other',
};

export const VACANCY_STATUSES = ['pending_approval', 'open', 'filled', 'closed', 'rejected'];

export const VACANCY_STATUS_LABELS = {
  pending_approval: 'Awaiting approval',
  open: 'Open',
  filled: 'Filled',
  closed: 'Closed',
  rejected: 'Rejected',
};

export const REASONS = ['growth', 'replacement', 'other'];

export const REASON_LABELS = {
  growth: 'Growth',
  replacement: 'Replacement',
  other: 'Other',
};

// A candidate who has sat in one stage this long is flagged on the board.
export const STALLED_AFTER_DAYS = 7;

// Interviews. The type says which stage it belongs to, so booking one can
// move the candidate there in the same step.
export const INTERVIEW_TYPES = ['screening', 'interview_1', 'interview_2', 'other'];

export const INTERVIEW_TYPE_LABELS = {
  screening: 'Screening call',
  interview_1: 'Interview 1',
  interview_2: 'Interview 2 / technical',
  other: 'Other',
};

export const INTERVIEW_TYPE_STAGE = {
  screening: 'screening',
  interview_1: 'interview_1',
  interview_2: 'interview_2',
};

export const RECOMMENDATIONS = ['proceed', 'hold', 'reject'];

export const RECOMMENDATION_LABELS = {
  proceed: 'Proceed',
  hold: 'Hold',
  reject: 'Reject',
};

// Offers. Within the vacancy's band an offer is approved on creation; above it,
// the offer approver decides. Accepted is the hand-off into Onboarding.
export const OFFER_STATUSES = ['pending_approval', 'approved', 'rejected', 'sent', 'accepted', 'declined', 'withdrawn'];

export const OFFER_STATUS_LABELS = {
  pending_approval: 'Offer awaiting approval',
  approved: 'Offer approved',
  rejected: 'Offer refused by approver',
  sent: 'Offer sent',
  accepted: 'Offer accepted',
  declined: 'Offer declined',
  withdrawn: 'Offer withdrawn',
};

// Board card tint: rejected candidates read red whatever their offer says;
// otherwise a card with an offer takes the offer's colour, matching its badge.
const OFFER_CARD_TINT = {
  pending_approval: 'bg-amber-50 border-amber-200',
  approved: 'bg-blue-50 border-blue-200',
  rejected: 'bg-red-50 border-red-200',
  sent: 'bg-purple-50 border-purple-200',
  accepted: 'bg-green-50 border-green-200',
  declined: 'bg-red-50 border-red-200',
  withdrawn: 'bg-gray-50 border-gray-200',
};

export function candidateCardTint(c) {
  if (c.status === 'rejected') return 'bg-red-50 border-red-200';
  return OFFER_CARD_TINT[c.offer_status] || 'bg-white border-gray-200';
}
